/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Schedule_CronInputs */

const cs_automation_schedule_cron = /** @type {(inputs: Automation_Schedule_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron plán`)
};

const en_automation_schedule_cron = /** @type {(inputs: Automation_Schedule_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron schedule`)
};

/**
* | output |
* | --- |
* | "Cron schedule" |
*
* @param {Automation_Schedule_CronInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_schedule_cron = /** @type {((inputs?: Automation_Schedule_CronInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Schedule_CronInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_schedule_cron(inputs)
	return cs_automation_schedule_cron(inputs)
});